import { render, staticRenderFns } from "./KeyboardInput.vue?vue&type=template&id=4126f8f3&scoped=true"
import script from "./KeyboardInput.vue?vue&type=script&lang=js"
export * from "./KeyboardInput.vue?vue&type=script&lang=js"
import style0 from "./KeyboardInput.vue?vue&type=style&index=0&id=4126f8f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4126f8f3",
  null
  
)

export default component.exports